import { BaseService } from "../../base";
export class JobService extends BaseService() {
    static get entity() {
        return "job";
    }
    static get responseName() {
        return "job";
    }
}
